<template>
  <div class="nav-scroller border-bottom">
    <div class="nav nav-tabs">
      <a href="#" class="nav-link"
         v-bind:class="{ 'active': currentSection === 'GeneralInformation' }"
         @click="showSection('GeneralInformation')">
        Información general</a>
      
      <a :href="`${protocol.url}/consultar`"
         class="nav-link">
        Consultar el protocolo</a>
      
      <a href="#" class="nav-link"
         data-target="#users-modal"
         data-toggle="modal"
         @click="showSection('AssignReviewers')">
        Asignar revisores</a>
      
      <a href="#" class="nav-link"
         v-bind:class="{ 'active': currentSection === 'DictumProtocol' }"
         @click="showSection('DictumProtocol')">
        Dictaminar protocolo</a>
      
      <a href="#" class="nav-link"
         v-bind:class="{ 'active': currentSection === 'PreviousStageReport' }"
         @click="showSection('PreviousStageReport')">
        Informe de la etapa anterior</a>
      
      <a href="#" class="nav-link"
         v-bind:class="{ 'active': currentSection === 'CancelProtocol' }"
         @click="showSection('CancelProtocol')">
        Cancelar protocolo</a>
    </div>
  </div>
</template>

<script>
  
  export default {
    name: 'CommitteeDictumTabs',
    props: {
      protocol: Object,
    },
    data() {
      return {
        currentSection: 'GeneralInformation',
      }
    },
    methods: {
      showSection(section) {
        this.currentSection = section
        
        this.$emit('show-section', section)
      },
    },
  }
</script>
